import LoadingState from "../common/LoadingState";

type Props = {
  variant?: "dots" | "table" | "cards" | "page";
};

const ThreeDotsLoader = ({ variant = "dots" }: Props) => {
  return <LoadingState variant={variant} />;
};

export default ThreeDotsLoader;
